Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.validationApiMethodType = "GET";
exports.exampleAPiEndPoint = "EXAMPLE_URL";
exports.exampleAPiMethod = "POST";
exports.exampleApiContentType = "application/json";
exports.textInputPlaceHolder = "Enter Text";
exports.labelTitleText = "NavigationMenu";
exports.labelBodyText = "NavigationMenu Body";

exports.btnExampleTitle = "CLICK ME";

exports.openDrawerText = "Open Drawer";
exports.userName = "Jordan Ramsay";
exports.userDesignation = "Miami Herica";
exports.logout = "Logout";

exports.TOKEN = "token"
exports.REFRESH_TOKEN = "refresh_token"
exports.PROFILE_KEY = "profile"
exports.COMET_AUTH_TOKEN_KEY = "comet_auth_token"
exports.logoutText = "Log Out"
exports.logoutDescription = "Are you sure you want to log out?"
exports.jsonApiContentType = "application/json";
exports.getMenuItemsEndPoint = "navmenu/navigation_menu";
exports.getApiMethodType = "GET";
exports.httpPostMethod = "POST"
exports.getNotification = "bx_block_notifications/notifications";
exports.quickLinksText = "Quick Links"
exports.emailAddressText = "Email address"
exports.successSubscribeMessage = "Thank you for subscribing! You will now receive the latest news and announcements."
exports.subscribeUpdatesApiEndpoint = "bx_block_content_management/subscribe_email"
exports.userProfileApiEndpoint = "account_block/show_user_with_token"

exports.FACEBOOK_PAGE_URL = "https://www.facebook.com/profile.php?id=61570113907990"
exports.INSTAGRAM_PAGE_URL = "https://www.instagram.com/bharat_stage"
exports.X_PAGE_URL = "https://x.com/BharatStage"
// Customizable Area End